import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/AuthContext';
import { Toaster } from 'sonner';
import { detectInitialLang, setLang } from './lib/i18n';
import Landing from './pages/Landing';
import EnLanding from './pages/EnLanding';
import Auth from './pages/Auth';
import OmStillerom from './pages/OmStillerom';
import AuthCallback from './pages/AuthCallback';
import AppLayout from './pages/AppLayout';
import Dashboard from './pages/Dashboard';
import ChatList from './pages/ChatList';
import ChatView from './pages/ChatView';
import Mood from './pages/Mood';
import Breathing from './pages/Breathing';
import Resources from './pages/Resources';
import CheckIn from './pages/CheckIn';
import Settings from './pages/Settings';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Feedback from './pages/Feedback';
import AdminFeedback from './pages/AdminFeedback';
import AdminAnalytics from './pages/AdminAnalytics';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-inkSoft">Laster…</div>;
    if (!user) return <Navigate to="/auth" replace />;
    return children;
}

function AppRouter() {
    const location = useLocation();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes('session_id=')) {
        return <AuthCallback />;
    }
    return (
        <>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/en" element={<EnLanding />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/personvern" element={<Privacy />} />
                <Route path="/vilkar" element={<Terms />} />
                <Route path="/om" element={<OmStillerom />} />
                <Route path="/tilbakemelding" element={<Feedback standalone />} />
                <Route path="/app" element={<Protected><AppLayout /></Protected>}>
                    <Route index element={<Dashboard />} />
                    <Route path="samtaler" element={<ChatList />} />
                    <Route path="samtale/:sessionId" element={<ChatView />} />
                    <Route path="humor" element={<Mood />} />
                    <Route path="pust" element={<Breathing />} />
                    <Route path="innsjekk" element={<CheckIn />} />
                    <Route path="ressurser" element={<Resources />} />
                    <Route path="konto" element={<Settings />} />
                    <Route path="tilbakemelding" element={<Feedback />} />
                    <Route path="admin/tilbakemelding" element={<AdminFeedback />} />
                    <Route path="admin/analytics" element={<AdminAnalytics />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <InstallPrompt />
        </>
    );
}

export default function App() {
    // Initialize language on first paint
    React.useEffect(() => {
        const initial = detectInitialLang();
        setLang(initial);
    }, []);
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRouter />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </AuthProvider>
    );
}
